// Image Animation on Scroll
function isElementInViewport(el, offset) {
  var rect = el.getBoundingClientRect();
  var viewportHeight =
    window.innerHeight || document.documentElement.clientHeight;
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  var centerX = rect.left + rect.width / 3;
  var centerY = rect.top + rect.height / 3;

  return (
    centerY >= -offset &&
    centerY <= viewportHeight + offset &&
    centerX >= 0 &&
    centerX <= viewportWidth
  );
}

function animateOnScroll() {
  var elements = document.querySelectorAll("img");
  var offset = 100; // Adjust the offset value as needed
  for (var i = 0; i < elements.length; i++) {
    if (isElementInViewport(elements[i], offset)) {
      elements[i].classList.add("visible");
    }
  }
}

function addVisibleClassToImagesOnLoad() {
  var images = document.querySelectorAll("img");
  var offset = 0; // Adjust the offset value as needed

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, {
    root: null,
    rootMargin: offset + "px 0px", // Apply the offset as rootMargin
    threshold: 0
  });

  images.forEach(function(image) {
    observer.observe(image);
  });
}

function observeDOMChanges() {
  // Select all target elements to observe
  var targetNodes = document.querySelectorAll('facet-filters-form');

  // Iterate over each target node
  targetNodes.forEach(function(targetNode) {
    // Create a new MutationObserver instance for each target node
    var observer = new MutationObserver(function(mutationsList) {
      // Iterate over the mutations
      for (var mutation of mutationsList) {
        // Check if nodes are added or removed
        if (mutation.type === 'childList') {
          // Call the function to add visible class to images
          addVisibleClassToImagesOnLoad();
        }
      }
    });

    // Start observing the target node for DOM mutations
    observer.observe(targetNode, { 
      childList: true, 
      subtree: true 
    });
  })};


// Check if the "next" button exists before adding a click event listener
var nextButton = document.querySelector(".slider-button--next");
if (nextButton) {
  nextButton.addEventListener("click", function() {
    // Add a visible class to all slider images when the "next" button is clicked
    var sliderImages = document.querySelectorAll(".slider img");
    for (var i = 0; i < sliderImages.length; i++) {
      sliderImages[i].classList.add("visible");
    }
  });
}

// Add a swipe event listener for mobile devices
var touchStartX = 0;
var touchEndX = 0;

document.addEventListener("touchstart", function(event) {
  touchStartX = event.touches[0].clientX;
});

document.addEventListener("touchend", function(event) {
  touchEndX = event.changedTouches[0].clientX;

  // Calculate the difference between the start and end positions
  var swipeDistance = touchEndX - touchStartX;

  // You can adjust this threshold to control the sensitivity of the swipe
  var swipeThreshold = 50; // Adjust as needed

  // If the swipe distance is greater than the threshold, trigger the visibility animation
  if (Math.abs(swipeDistance) > swipeThreshold) {
    // Add a visible class to all slider images when a swipe occurs
    var sliderImages = document.querySelectorAll(".slider img");
    for (var i = 0; i < sliderImages.length; i++) {
      sliderImages[i].classList.add("visible");
    }
  }
});

// Call the function on page load
addVisibleClassToImagesOnLoad();
document.addEventListener('shopify:section:select', function() {
  observeDOMChanges();
});
observeDOMChanges();

animateOnScroll();
document.addEventListener("shopify:section:load", animateOnScroll);

// Add a scroll event listener to call the function when the user scrolls
window.addEventListener("scroll", animateOnScroll);
